export var PopoverCssClass;
(function (PopoverCssClass) {
    PopoverCssClass["Base"] = "iress-popover";
    PopoverCssClass["InputActivator"] = "iress-popover--input";
    PopoverCssClass["Active"] = "iress-popover--active";
    PopoverCssClass["Content"] = "iress-popover__content";
    PopoverCssClass["Activator"] = "iress-popover__activator";
    PopoverCssClass["Inline"] = "iress-popover--inline";
})(PopoverCssClass || (PopoverCssClass = {}));
export var PopoverType;
(function (PopoverType) {
    PopoverType["Menu"] = "menu";
    PopoverType["Listbox"] = "listbox";
    PopoverType["Tree"] = "tree";
    PopoverType["Grid"] = "grid";
    PopoverType["Dialog"] = "dialog";
})(PopoverType || (PopoverType = {}));
export var PopoverSlot;
(function (PopoverSlot) {
    PopoverSlot["Activator"] = "activator";
})(PopoverSlot || (PopoverSlot = {}));
//# sourceMappingURL=popover.types.js.map